import { Button, Card, Form, Layout, PageHeader, Select, Table, Typography } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { apiClient, apiErrorMessage } from '../../utils';
import { FilterOutlined, ReloadOutlined } from '@ant-design/icons';
import { useForm } from 'antd/lib/form/Form';

export function TaskCountsReport() {
  const { Content } = Layout;
  const { Text } = Typography;
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [taskCounts, setTaskCounts] = useState<any[]>();

  const [filtersOpen, setFiltersOpen] = useState(false);
  const [filterValues, setFilterValues] = useState<any>(undefined);
  const [filterResetTrigger, setFilterResetTrigger] = useState(0);

  const onBackClick = () => {
    history.goBack();
  };

  const loadTaskCounts = useCallback(() => {
    setLoading(true);

    const queryParams = [];
    if (filterValues) {
      if (filterValues.dateRange && filterValues.dateRange !== 'ALL') {
        queryParams.push(`dateRange=${filterValues.dateRange}`);
      }
    }

    const queryParamsStr = queryParams.join('&');

    apiClient
      .get(`reports/task-counts?${queryParamsStr}`)
      .then((response: any) => {
        setTaskCounts(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => setLoading(false));
  }, [filterValues]);

  useEffect(() => {
    loadTaskCounts();
  }, [loadTaskCounts]);

  const onRefreshClick = () => {
    loadTaskCounts();
  };

  const onFiltersToggle = () => {
    setFiltersOpen(!filtersOpen);
  };

  const onClearFiltersClick = () => {
    setFilterValues(undefined);
    setFilterResetTrigger(filterResetTrigger => filterResetTrigger + 1);
  };

  const onFiltersChange = (newFilterValues: any) => {
    setFilterValues(newFilterValues);
  };

  const tableColumns = [
    {
      title: 'Veri seti',
      dataIndex: ['gridName'],
      key: 'grid',
      render: (gridName: string, taskCounts: any) => (
        <Text strong={!taskCounts.fieldName} style={{ paddingLeft: !taskCounts.fieldName ? 0 : 20 }}>
          {gridName}
        </Text>
      ),
    },
    {
      title: 'Veri elemanı',
      dataIndex: ['fieldName'],
      key: 'field',
    },
    {
      title: 'Bekleyen görevler',
      dataIndex: ['nonCompletedCount'],
      key: 'nonCompletedCount',
    },
    {
      title: 'Tamamlanan görevler',
      dataIndex: ['completedCount'],
      key: 'completedCount',
    },
    {
      title: 'Toplam görevler',
      dataIndex: ['totalCount'],
      key: 'totalCount',
    },
  ];

  return (
    <>
      <PageHeader
        title="Görev sayıları"
        onBack={onBackClick}
        extra={[
          <>
            {filterValues && (
              <Button type="link" onClick={onClearFiltersClick}>
                Tüm filtreleri temizle
              </Button>
            )}
          </>,
          <Button key="filters" onClick={onFiltersToggle} icon={<FilterOutlined />}>
            Filtreleri {filtersOpen ? 'gizle' : 'göster'}
          </Button>,
          <Button key="refresh" onClick={onRefreshClick} icon={<ReloadOutlined />}>
            Yenile
          </Button>,
        ]}
      />
      <Content>
        <FiltersForm hidden={!filtersOpen} onChange={onFiltersChange} resetTrigger={filterResetTrigger} />
        <Table columns={tableColumns} dataSource={taskCounts} pagination={false} loading={loading} scroll={{ x: '100%' }} />
      </Content>
    </>
  );
}

function FiltersForm(props: { hidden: boolean; resetTrigger: number; onChange: (filterValues: any) => void }) {
  const { Option } = Select;
  const [form] = useForm();

  useEffect(() => {
    form.resetFields();
  }, [form, props.resetTrigger]);

  const onChange = () => {
    const values = form.getFieldsValue();
    props.onChange(values);
  };

  if (props.hidden) {
    return null;
  }

  return (
    <Card style={{ marginBottom: '2rem' }}>
      <Form form={form} layout="inline">
        <Form.Item name="dateRange">
          <Select allowClear placeholder="Zaman aralığı" style={{ width: '12rem' }} onChange={onChange}>
            <Option value="ONE_DAY">1 gün</Option>
            <Option value="ONE_WEEK">1 hafta</Option>
            <Option value="TWO_WEEKS">2 hafta</Option>
            <Option value="ONE_MONTH">1 ay</Option>
            <Option value="ONE_YEAR">1 yıl</Option>
            <Option value="ALL">Tümü</Option>
          </Select>
        </Form.Item>
      </Form>
    </Card>
  );
}
